import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { AuthGuard } from 'src/app/shared/guard/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: { breadcrumbI18nKey: 'DASHBOARD' },
        loadChildren: () =>
          import('../../main/module/dashboard/dashboard.module')
            .then(m => m.DashboardModule)
      },
      {
        path: 'basedata',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: { breadcrumbI18nKey: 'BasicData' },
        loadChildren: () =>
          import('../../main/module/base-data/base-data.module')
            .then(m => m.BaseDataModule)
      },
      {
        path: 'engineeringapplication',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: { breadcrumbI18nKey: 'EngineeringApplication' },
        loadChildren: () =>
          import('../../main/module/engineering-application/engineering-application.module')
            .then(m => m.EngineeringApplicationModule)
      },
      {
        path: 'invoicessigned',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: { breadcrumbI18nKey: 'DocApproval' },
        loadChildren: () =>
          import('../module/invoices-signed/invoices-signed.module').then(
            (m) => m.InvoicesSignedModule
          ),
      },
      {
        path: 'approximateamount',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: { breadcrumbI18nKey: 'VendorAppointmentAndBudget' },
        loadChildren: () =>
          import('../module/approximate-amount/approximate-amount.module').then(
            (m) => m.ApproximateAmountModule
          ),
      },
      {
        path: 'manufacturerbid',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: { breadcrumbI18nKey: 'VendorBid' },
        loadChildren: () =>
          import('../module/manufacturer-bid/manufacturer-bid.module').then(
            (m) => m.ManufacturerBidModule
          ),
      },
      {
        path: 'inquiry',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: { breadcrumbI18nKey: 'Inquiry' },
        loadChildren: () =>
          import('../module/inquiry/inquiry.module').then(
            (m) => m.InquiryModule
          ),
      },
      {
        path: 'report',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: { breadcrumbI18nKey: 'REPORT' },
        loadChildren: () =>
          import('../module/report/report.module').then(
            (m) => m.ReportModule
          ),
      },
      /* {
        path: 'detailapplication',
        loadChildren: () =>
          import('../module/detail-application/detail-application.module').then(
            (m) => m.DetailApplicationModule
          ),
      } */
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class LayoutRoutingModule {
}
